<div class="modal-header">
  <h5 class="modal-title">
    {{ "conclusionPage.conclusion" | translate }}
  </h5>
  <button
    type="button"
    class="btn-close"
    (click)="activeModal.dismiss()"
  ></button>
</div>

<div class="modal-body">
  <app-conclusion
    [patientId]="patientId"
    [woundId]="woundId"
    [isModal]="true"
    [isConclusionExist]="true"
    (close)="activeModal.close()"
  ></app-conclusion>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.dismiss()">
    {{ "cancel" | translate }}
  </button>

  <button class="btn btn-primary" (click)="complete()">
    {{ "conclusionPage.completeConclusion" | translate }}
  </button>
</div>
